<template>
  <v-layout wrap>
    <v-radio-group
      v-model="selected"
      hide-details
      row
      class="mt-0 pt-0"
      @change="change"
    >
      <v-radio
        label="Все поставки"
        :value="0"
      />
      <v-radio
        label="Заезд"
        :value="1"
      />
      <v-radio
        label="Свозка"
        :value="3"
      />
    </v-radio-group>
  </v-layout>
</template>
<script>
import { phaseTypes } from "./shipping-phase-types.js";
export default {
  data() {
    return {
      selected: 0,
    };
  },
  computed: {
    types() {
      return phaseTypes;
    },
    phaseType() {
      return this.$store.getters["routePlanning/phaseType"];
    },
  },
  watch: {
    phaseType: {
      handler(value) {
        if (value?.pickup) {
          this.selected = this.types.PICKUP;
        } else if (value?.combination) {
          this.selected = this.types.COMBINATION;
        } else {
          this.selected = 0;
        }
      },
      immediate: true,
    },
  },
  methods: {
    change() {
      const shippingPhaseType = {
        pickup: this.selected === this.types.PICKUP ? true : false,
        combination: this.selected === this.types.COMBINATION ? true : false,
      };
      this.$store.commit("routePlanning/setPhaseType", shippingPhaseType);
      this.$store.commit("routePlanning/setFilterIsActive", true);
      this.$emit("change");
    },
  },
};
</script>
